export const objectStateComparator = (oldState, newState) => {
  var result = [];

  try {
    if (!oldState || !Array.isArray(oldState) || oldState ?.length === 0) {
      return result;
    }

    if (!newState || !Array.isArray(newState) || newState ?.length === 0) {
      return result;
    }

    // Create new copies 
    oldState = oldState.slice(0);
    newState = newState.slice(0);

    // Deleted Objects
    mismatchingObjects(oldState, newState, result);

    oldState.forEach((object) => {
      const report = {};
      report.id = object ?.id;
      const matches = newState.filter((item) => {
        return item ?.id === object ?.id;
      });
      const mlen = matches.length;
      if (mlen) {
        if (mlen === 1 && stringMatch(object, matches[0])) {
          return;
        }
        if (mlen > 1) {
          report.hasDuplicate = true;
        }
        matches.forEach((match, index) => {
          if (stringMatch(object, match)) return;
          keyMatches(object, match, index, report);
          matchValue(null, object, match, index, report);
        });
      }
      if (Object.keys(report).length > 1) {
        result.push(report);
      }
    });
    return result;
  } catch (error) {
    return error; // dont want the update to fail due to a processing error here - do not throw the error
  }
};

const stringMatch = (sourceObject, updatedObject) => {
  return JSON.stringify(sourceObject) === JSON.stringify(updatedObject);
};

const keyMatches = (sourceObject, updatedObject, index, report) => {
  const k1 = Object.keys(sourceObject);
  const k2 = Object.keys(updatedObject);
  if (k1.join() !== k2.join()) {
    report.keysRemoved = (report.keysRemoved || []);
    const removed = k1.filter((key) => {
      return k2.indexOf(key) < 0;
    });
    if (removed ?.length > 0) {
      report.keysRemoved.push({
        keys: removed
      });
    }
    report.keysAdded = (report.keysAdded || []);
    const added = k2.filter((key) => {
      return k1.indexOf(key) < 0;
    });
    if (added ?.length > 0) {
      const values = added.map(entry => {
        return updatedObject[entry];
      });
      report.keysAdded.push({
        keys: added,
        values
      });
    }
  }
};

const matchValue = (parentKey, sourceObject, updatedObject, index, report) => {
  report.keysChanged = report.keysChanged || [];
  const keys = [];
  for (var key in sourceObject) {
    if (sourceObject[key] !== updatedObject[key] && updatedObject[key]) {
      if (Array.isArray(sourceObject[key])) {
        mismatchingObjects(sourceObject[key], updatedObject[key], keys);
        if (Array.isArray(updatedObject[key]) && updatedObject[key].length > 0) {
          sourceObject[key].forEach((entry, index) => {
            matchValue(key, entry, updatedObject[key][index], index, report);
          });
        }
      } else {
        keys.push(key.concat(' updated from ').concat(sourceObject[key]).concat(' to ').concat(updatedObject[key]));
      }
    }
  }
  if (keys ?.length > 0) {
    const objectId = sourceObject ?.id ? sourceObject ?.id : index;
    report.keysChanged.push({
      keys,
      objectId
    });
  }
};

const mismatchingObjects = (sourceObject, updatedObject, result) => {
  const ids1 = sourceObject.map(function (object) {
    return object.id;
  });
  const ids2 = updatedObject.map((object) => {
    return object.id;
  });
  ids1.forEach(function (id) {
    if (ids2.indexOf(id) < 0)
      result.push({
        id: id,
        status: 'Object Deleted '.concat(JSON.stringify(sourceObject))
      });
  });

  ids2.forEach((id) => {
    if (ids1.indexOf(id) < 0)
      result.push({
        id: id,
        status: 'Object Added'.concat(JSON.stringify(updatedObject))
      });
  });
};

export const auditLogHeaderEntry = (auditEntry) => {
  if (auditEntry) {
    return { auditLogEntry: JSON.stringify(auditEntry) };
  }
  return null;
};



// WEBPACK FOOTER //
// ./services/auditService.js